import MODAL_TEMPLATE_URL from "emun.auth/register-current-acct-prompt.htm";
import open from "webmodals/open";
import RegisterCurrentAcctPromptController from "emun.auth/register-current-acct-prompt.controller";

export default ({
  size = "md",
  backdrop = "static",
  templateUrl = MODAL_TEMPLATE_URL,
  userName,
  email,
  retailerId,
  title = "Create a user account...",
  ...options
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    controller: RegisterCurrentAcctPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      title: () => title,
      userName: () => userName,
      email: () => email,
      retailerId: () => retailerId,
      options: () => ({ title, ...options }),
    },
  }).result;
